import { render, staticRenderFns } from "./filtroRelatorio.vue?vue&type=template&id=b777a7ca"
import script from "./filtroRelatorio.vue?vue&type=script&lang=js"
export * from "./filtroRelatorio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports